"use client"

import { PcCase } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `PcCaseIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const PcCaseIcon = component(Icon)({ as: PcCase })
